<template>
    <div class="editBuild">
        <ul class="add_build_alert_building_info">
            <li class="add_build_alert_building_info_item">
                <span class="add_build_alert_building_info_title">
                    <i style="color:#F56C6C;padding-right:6px;">*</i>栋座
                </span>
                <div class="add_build_alert_building_info_content">
                    <el-input
                        class="uiint_info_prefix"
                        placeholder="前缀"
                        v-model="addBuildInfo.tungPrefix"
                    ></el-input>
                    <el-input v-model="addBuildInfo.indexTung"></el-input>
                    <el-select
                        v-model="addBuildInfo.suffix"
                        placeholder
                        @visible-change="getBuildType"
                    >
                        <el-option
                            v-for="(item,index) in buildType"
                            :key="index"
                            :label="item.valueDesc"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </div>
            </li>
            <li class="add_build_alert_building_info_item">
                <span class="add_build_alert_building_info_title">
                    <i style="color:#F56C6C;padding-right:3px;">*</i>顺序
                </span>
                <div class="add_build_alert_building_info_content">
                    <el-input type="number" min="1" v-model="addBuildInfo.sort"></el-input>
                </div>
            </li>
        </ul>
        <ul class="building_rules">
            <li class="building_rules_item">
                <span>用途</span>
                <el-select
                    class="uiint_info_unit"
                    v-model="addBuildInfo.purpose"
                    placeholder="请选择"
                    :disabled="true"
                    @visible-change="getUseData"
                >
                    <el-option
                        v-for="(item,index) in useData"
                        :key="index"
                        :label="item.valueDesc"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </li>
            <li class="building_rules_item">
                <span>土地期限</span>
                <el-select
                    class="uiint_info_unit"
                    v-model="addBuildInfo.landTenure"
                    placeholder="请选择"
                    @visible-change="getLandTermData"
                >
                    <el-option
                        v-for="(item,index) in landTermData"
                        :key="index"
                        :label="item.valueDesc"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </li>
            <!-- <li class="building_rules_item">
                <span>建筑类型</span>
                <el-select
                    class="uiint_info_unit"
                    v-model="addBuildInfo.architecturalType"
                    placeholder="请选择"
                    @visible-change="getBuildingType"
                >
                    <el-option
                        v-for="(item,index) in buildingType"
                        :key="index"
                        :label="item.valueDesc"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </li> -->
            <li class="building_rules_item">
                <span>土地性质</span>
                <el-select
                    class="uiint_info_unit"
                    v-model="addBuildInfo.landCharacteristic"
                    placeholder="请选择"
                    @visible-change="getLandNature"
                >
                    <el-option
                        v-for="(item,index) in landNatureData"
                        :key="index"
                        :label="item.valueDesc"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </li>
        </ul>
        <ul class="building_rules">
            <li class="building_rules_item">
                <span>权利性质</span>
                <el-select
                    class="uiint_info_unit"
                    v-model="addBuildInfo.natureOfRights"
                    placeholder="请选择"
                    @visible-change="getDroitNature"
                >
                    <el-option
                        v-for="(item,index) in droitNatureData"
                        :key="index"
                        :label="item.valueDesc"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </li>
            <li class="building_rules_item">
                <span>建筑结构</span>
                <el-select
                    class="uiint_info_unit"
                    v-model="addBuildInfo.buildingStructure"
                    placeholder="请选择"
                    @visible-change="getStructureData"
                >
                    <el-option
                        v-for="(item,index) in structureData"
                        :key="index"
                        :label="item.valueDesc"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </li>
            <li class="building_rules_item">
                <span>建筑年代</span>
                <el-date-picker
                    class
                    v-model="addBuildInfo.buildingYears"
                    value-format="yyyy"
                    type="year"
                    placeholder="选择日期"
                ></el-date-picker>
                <!-- <el-select class="uiint_info_unit" v-model="addBuildInfo.buildingYears" placeholder="请选择" @visible-change="getBuildAgesData">
          <el-option v-for="(item,index) in buildAgesData" :key="index" :label="item.valueDesc" :value="item.value">
          </el-option>
                </el-select>-->
            </li>
        </ul>
        <ul class="building_rules last_building_rule"></ul>
        <div class="alert_footer">
            <div class="foot_btns">
                <button class="cancel_btn" @click="removeTheBtn">取消</button>
                <button v-points class="save_btn" @click="saveBuildBtn">保存</button>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
import { dicGet } from "@/api";
export default {
    naem: "editBuild",
    props: {
        curBuildData: {}
    },
    data() {
        return {
            isActive: true,
            buildType: [{ valueDesc: "栋", value: "BUILD" }], //栋座后缀
            unitData: [], //单元后缀
            roomRuleData: [
                { valueDesc: "按楼层排号", value: "0" },
                { valueDesc: "按单元排号", value: "1" }
            ], //房号规则
            ruleBeforeData: [
                { valueDesc: "无", value: "1" },
                { valueDesc: "楼层", value: "0" }
            ], //规则组成前缀
            ruleAfterData: [], //规则组成后缀
            useData: [], //用途列表
            landTermData: [], //土地期限列表
            buildingType: [], //建筑类型列表
            landNatureData: [], //土地性质列表
            droitNatureData: [], //权利性质列表
            structureData: [], //建筑结构列表
            buildAgesData: [], //建筑年代列表
            storeData: [], //负责人门店列表
            employeeData: [], //负责人列表
            addBuildInfo: {
                // employeeId: '', // 员工编号
                residentialAreaId: "", // 小区编号
                sort: "", // 顺序
                indexTung: "", //  起始楼栋号
                lastTung: "", //  结束楼栋号
                suffix: "", //  栋座单位： 1、 栋 2、 弄 3、 座 4、 号楼 5、 胡同
                tungPrefix: "", //  楼栋前缀
                indexFloor: "", // 起始楼层
                lastFloor: "", //  结束楼层
                // totalFloor: '', //   总层数
                indexUnit: "", //  单元开始
                lastUnit: "", //  单元结束
                unitSuffix: "", //  单元单位： 1: 单元 2: 栋 3: 号 4: 号楼
                unitPrefix: "", //   单元前缀
                roomNumberRule: "", //   房号规则， 按楼层排号、 按单元排号 默认： 按楼层排号
                ruleCompositionPrefix: "", //  组成规则前缀， 楼层、 无
                ruleCompositionSufix: "", //  组成规则后缀 数字、 字母
                elevatorNo: "", //  梯数
                households: "", //  户数
                purpose: "", //  楼栋用途， 住宅、 别墅、 商铺、 写字楼、 厂房、 仓库、 车库
                landTenure: "", //  土地期限， 40 年、 50 年、 70 年
                // architecturalType: "", //  楼栋建筑类型: '',//
                landCharacteristic: "", //  土地性质， 出让、 划拨
                natureOfRights: "", //  权利性质
                buildingStructure: "", // (required) 楼栋建筑结构
                buildingYears: "" //  建筑年代
                // liableEmployeeStoreId: '', //  责任人门店， 默认为当前登陆员工所属门店
                // liableEmployeeId: '' //  责任人， 默认为本系统当前登陆员工
            },
            empId: ""
        };
    },
    mounted() {
        let params = Object.assign({}, this.curBuildData);
        params.indexTung = params.number;
        params.tungPrefix = params.prefix;
        this.addBuildInfo = params;
        this.getBuildType(true);
        this.getUseData(true);
        this.getLandTermData(true);
        this.getBuildingType(true);
        this.getLandNature(true);
        this.getDroitNature(true);
        this.getStructureData(true);
        this.getBuildAgesData(true);
        let StoreId = parseInt(sessionStorage.getItem("storeId"));
        this.employeeData = [
            { name: this.employeeName, employeeId: this.empId }
        ];
    },
    watch: {
        curBuildData: function() {
            if (this.curBuildData) {
                this.addBuildInfo = Object.assign({}, this.curBuildData);
                console.log(2222222, this.addBuildInfo);
            }
        }
    },
    methods: {
        getBuildType(val) {
            // 查询栋座类型
            if (val) {
                let params = {
                    code: "tung"
                };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        //cosole.log(res)
                        this.buildType = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },

        getUnitData(val) {
            // 查询单元

            if (val) {
                let params = {
                    code: "unit"
                };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        //cosole.log(res)
                        this.unitData = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 查询规则组成前缀
        getRuleBeforerData(val) {
            if (val) {
                let params = {
                    employeeId: this.empId,
                    code: "ruleBeforePrefixEnums"
                };
                getScreening(params).then(res => {
                    if (res.success) {
                        //cosole.log(res)
                        this.ruleBeforeData = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 查询规则组成
        getRuleAfterData(val) {
            if (val) {
                let params = {
                    employeeId: this.empId,
                    code: "ruleAfterPrefixEnums"
                };
                getScreening(params).then(res => {
                    if (res.success) {
                        //cosole.log(res)
                        this.ruleAfterData = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 查询房号规则
        getRoomRuleData(val) {
            if (val) {
                let params = {
                    employeeId: this.empId,
                    code: "houseRoomRuleEnums"
                };
                getScreening(params).then(res => {
                    if (res.success) {
                        //cosole.log(res)
                        this.roomRuleData = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },

        changeHouseRule() {
            //cosole.log(222222,this.addBuildInfo.roomNumberRule)
            if (this.addBuildInfo.roomNumberRule == 0) {
                // 按照楼层排序
                this.ruleAfterData = [
                    { valueDesc: "字母", value: "2" },
                    { valueDesc: "数字", value: "3" }
                ];
                //cosole.log(3333)
            } else {
                this.ruleAfterData = [{ valueDesc: "数字", value: "3" }];
                this.addBuildInfo.ruleCompositionSufix = "3";
                //cosole.log(355555)
            }
        },

        // 查询用途
        getUseData(val) {
            if (val) {
                let params = {
                    code: "tungPurpose"
                };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        //cosole.log(res)
                        this.useData = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 查询土地期限
        getLandTermData(val) {
            if (val) {
                let params = {
                    code: "landTenure"
                };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        //cosole.log(res)
                        this.landTermData = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 查询建筑类型
        getBuildingType(val) {
            if (val) {
                let params = {
                    code: "tungArchitecturalType"
                };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        //cosole.log(res)
                        this.buildingType = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 查询土地性质
        getLandNature(val) {
            if (val) {
                let params = {
                    code: "landCharacteristic"
                };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        //cosole.log(res)
                        this.landNatureData = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 查询权利性质
        getDroitNature(val) {
            if (val) {
                let params = {
                    code: "natureRights"
                };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        //cosole.log(res)
                        this.droitNatureData = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 查询建筑结构
        getStructureData(val) {
            if (val) {
                let params = {
                    code: "buildingStructure"
                };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        //cosole.log(res)
                        this.structureData = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 查询建筑年代
        getBuildAgesData(val) {
            if (val) {
                let params = {
                    code: "architectural_age"
                };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        //cosole.log(res)
                        this.buildAgesData = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                });
            }
        },
        // 取消按钮
        removeTheBtn() {
            this.$emit("removSaveBtn");
        },
        // 保存按钮
        saveBuildBtn() {
            if (this.isActive) {
                this.addBuildInfo.lastTung = this.addBuildInfo.indexTung;
            }
            if (!this.addBuildInfo.sort) {
                this.$message.error("顺序不能为空");
                return false;
            }
            if ((!(/(^[1-9]\d*$)/.test(this.addBuildInfo.sort)))) {
                this.$message.error("顺序应为正整数");
                return false;
            }
            this.$emit("saveBuildingBtn", this.addBuildInfo);
        }
    }
};
</script>
<style type="text/css" lang="less">
.editBuild {
    .add_build_left {
        display: flex;
        justify-content: space-between;
        padding: 0 40px;

        .content_add_type {
            .add_new_type {
                font-size: 14px;
            }

            .add_type_chouse_btn {
                border: 1px solid #5e75e6;
                border-radius: 4px;
                margin-top: 10px;
                display: flex;

                > li {
                    width: 120px;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    font-size: 14px;
                    color: #5e75e6;
                    cursor: pointer;

                    &.active {
                        background: #5e75e6;
                        color: white;
                    }
                }
            }
        }

        .single_number {
            .single_number_info {
                display: flex;
                align-items: center;
                margin-top: 10px;
                border: 1px solid #ccc;
                border-radius: 4px;
                background: #f5f5f5;
                padding-right: 10px;

                > span {
                    font-size: 14px;
                    color: #232323;
                }

                .el-input {
                    .el-input__inner {
                        height: 30px;
                        width: 50px;
                        padding-left: 5px;
                        padding-right: 5px;
                        text-align: center;
                        border: none;
                        background: #f5f5f5;
                    }
                }
            }
        }
    }

    .add_build_alert_building_info {
        display: flex;
        padding: 0 40px;
        margin-top: 30px;

        .add_build_alert_building_info_item {
            margin-right: 30px;
            .add_build_alert_building_info_content {
                border: 1px solid #ccc;
                background: #f5f5f5;
                display: flex;
                margin-top: 10px;
                border-radius: 4px;
                overflow: hidden;

                .el-input {
                    .el-input__inner {
                        width: 65px;
                        height: 30px;
                        font-size: 14px;
                        background: #f5f5f5;
                        border: none;
                        border-right: 1px solid #ccc;
                        padding-left: 10px;
                        padding-right: 10px;
                        border-radius: 0;
                    }
                }

                .el-select {
                    .el-input {
                        .el-input__inner {
                            width: 65px;
                            height: 30px;
                            font-size: 14px;
                            background: #f5f5f5;
                            border: none;
                            padding-left: 6px;
                            padding-right: 10px;
                        }

                        .el-input__icon {
                            line-height: 30px;
                            width: 16px;
                            right: 0;
                        }
                    }
                }
            }

            &.start_and_ending {
                margin-left: 30px;

                .add_build_alert_building_info_content {
                    align-items: center;

                    .el-input {
                        .el-input__inner {
                            width: 100px;
                            border: none;
                            text-align: center;
                        }
                    }
                }
            }

            &.uiint_info {
                .add_build_alert_building_info_content {
                    align-items: center;

                    .uiint_info_prefix {
                        .el-input__inner {
                            width: 50px;
                        }
                    }

                    .uiint_info_floor {
                        .el-input__inner {
                            width: 40px;
                            border: none;
                        }
                    }

                    .uiint_info_unit {
                        .el-input {
                            .el-input__inner {
                                width: 130px;
                                border-left: 1px solid #ccc;
                            }
                        }
                    }
                }
            }
        }
    }

    .building_rules {
        display: flex;
        padding: 0 40px;
        margin-top: 30px;

        .building_rules_item {
            display: flex;
            flex-direction: column;
            margin-right: 30px;

            > span {
                font-size: 14px;
                color: #232323;
            }

            .haoshi_el_input {
                margin-top: 10px;

                .el-input__inner {
                    width: 300px;
                    height: 30px;
                    background: #f5f5f5;
                }
            }

            .el-date-editor {
                .el-input__inner {
                    width: 150px !important;
                    height: 30px !important;
                    font-size: 14px;
                    background: #f5f5f5;
                    border: 1px solid #dcdfe6 !important;
                    border: none;
                    padding-left: 30px;
                    padding-right: 10px;
                    margin-top: 10px;
                }

                .el-input__icon {
                    display: none;
                    line-height: 30px !important;
                    width: 16px;
                    top: 5px;
                }
            }

            .el-select {
                margin-top: 10px;

                .el-input {
                    .el-input__inner {
                        width: 130px;
                        height: 30px;
                        background: #f5f5f5;
                    }

                    .el-input__icon {
                        line-height: 30px;
                    }
                }
            }

            .rules_item_content {
                display: flex;
                margin-top: 10px;
                border: 1px solid #ccc;
                width: 260px;
                height: 30px;
                overflow: hidden;
                border-radius: 4px;

                .el-input {
                    width: 110px;

                    .el-input__inner {
                        width: 130px;
                        height: 30px;
                        border: none;
                        background: #f5f5f5;
                        // border-right: 1px solid #ccc;
                        border-radius: 0;
                        box-sizing: border-box;
                    }

                    .el-input__icon {
                        line-height: 30px;
                    }
                }

                .el-select {
                    margin-top: 0;

                    .el-input {
                        .el-input__inner {
                            width: 130px;
                            height: 30px;
                            border: none;
                        }

                        .el-input__icon {
                            line-height: 30px;
                        }
                    }
                }

                .uiint_info_qianzhui {
                    .el-input {
                        .el-input__inner {
                            height: 30px;
                            border-right: 1px solid #ccc;
                        }

                        .el-input__icon {
                            line-height: 30px;
                            display: none;
                        }
                    }
                }
            }
        }

        &.last_building_rule {
            margin-bottom: 30px;
        }
    }

    .alert_footer {
        height: 80px;
        background: #f5f5f5;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .foot_btns {
            margin-right: 40px;

            > button {
                width: 80px;
                height: 40px;
                border-radius: 4px;
                outline: none;
                border: none;
                font-size: 16px;
                color: #ffffff;

                &.cancel_btn {
                    background: #999999;
                    margin-right: 20px;
                }

                &.save_btn {
                    background: #5e75e6;
                }
            }
        }
    }
}
</style>
